export default "__VITE_ASSET__08075aa4__"